export default __webpack_public_path__ + "static/b1-82d7c863ff535b4addef749128a18c8a.png";